import { Route } from '@angular/router';
import { TABS_CONFIG, TabsLayout } from '@incust-mobile/ui';
import { environment } from '../environments/environment';
import { PosDetailPage, PosListPage, PosMapPage, WelcomePage } from './pages';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full'
  },
  {
    path: 'welcome',
    component: WelcomePage
  },
  {
    path: 'home',
    component: TabsLayout,
    providers: [{ provide: TABS_CONFIG, useValue: environment.tabsConfig }],
    children: [
      {
        path: 'pos-list',
        component: PosListPage
      },
      {
        path: 'pos-map',
        component: PosMapPage
      },
      {
        path: '',
        redirectTo: 'main',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'pos-detail/:posId',
    component: PosDetailPage
  }
];
